export const voiceUrlFormate = (url) => {
  const mp3Index = String(url).indexOf(".mp3");
  const currentUrl = String(url).substring(0, mp3Index + 4);
  return currentUrl;
};
